<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
      <div class="detailsContent">
        <Photo :type='type' :id='id'></Photo>
      </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Photo from '@/components/Photo';
export default {
  data () {
    return {
      navBlock:'新聞  /  私密相簿',
      navtitle:'編輯相簿',
      type: 'edit',
      id: this.$route.query.id    }
  },
  created(){
  },
  methods:{
  },
  components: {
    NavBar,
    Photo
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/news/photoPrivacy/editPhoto.vue